import * as yup from 'yup';

export const counterAgentFormSchema = yup.object({
	name: yup.string().required(),
});

export const COUNTER_AGENT_DUPLICATE_ERROR = 466;
